module.exports = ng.common;